'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var utils = require('../utils');
var IconSpin = _interopDefault(require('../icon-spin'));

var toast = utils.create({
  render: function render() {
    var _vm = this;

    var _h = _vm.$createElement;

    var _c = _vm._self._c || _h;

    return _c('transition', {
      attrs: {
        "name": "toast"
      }
    }, [_c('div', {
      directives: [{
        name: "tap",
        rawName: "v-tap"
      }, {
        name: "show",
        rawName: "v-show",
        value: _vm.show,
        expression: "show"
      }],
      staticClass: "toast",
      on: {
        "touchmove": function touchmove($event) {
          $event.preventDefault();
        },
        "click": function click($event) {
          _vm.type !== 'loading' && _vm.onHide();
        }
      }
    }, [_vm.type === 'text' ? _c('div', {
      staticClass: "toast-message",
      domProps: {
        "innerHTML": _vm._s(_vm.text)
      }
    }) : _vm.type ? _c('div', {
      class: ['toast-box', "toast-box-".concat(_vm.type)]
    }, [_vm.type === 'loading' ? _c('icon-spin') : _vm.type === 'success' || _vm.type === 'error' ? _c('div', {
      class: "icon-".concat(_vm.type, "-outline")
    }) : _c('div', {
      class: "icon-".concat(_vm.type)
    }), _vm._v(" "), _vm.type === 'loading' ? _c('span', [_vm._v(_vm._s(_vm.text || '加载中...'))]) : _c('div', {
      domProps: {
        "innerHTML": _vm._s(_vm.text)
      }
    })], 1) : _vm._e(), _vm._v(" "), _vm.type === 'loading' ? _c('div', {
      staticClass: "toast-mask"
    }) : _vm._e()])]);
  },
  staticRenderFns: [],
  name: 'toast',
  props: {
    text: String,
    type: String,
    show: Boolean,
    onHide: Function
  },
  components: {
    IconSpin: IconSpin
  }
});

exports.default = toast;
